module.exports = __webpack_public_path__ + "img/default-payment-provider.f7d2409e.svg";